var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dashboard-nav-bar-wrapper"},[_c('div',{staticClass:"dashboard-nav-bar"},[_c('img',{attrs:{"src":"/applogo.png","width":"250","height":"32"}}),_vm._t("default",[_vm._v("dashboard navbar")])],2)])}
var staticRenderFns = []

export { render, staticRenderFns }